"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_select_dropdown_1 = require("../dropdown/awsui-select-dropdown");
var awsui_input_1 = require("./awsui-input");
var AutosuggestWrapper = /** @class */ (function (_super) {
    __extends(AutosuggestWrapper, _super);
    function AutosuggestWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutosuggestWrapper.prototype.findDropdown = function () {
        var dropdownElement = this.find('awsui-select-dropdown');
        if (dropdownElement) {
            return new awsui_select_dropdown_1.default(dropdownElement.getElement());
        }
        return null;
    };
    AutosuggestWrapper.prototype.findStatusIndicator = function () {
        var dropdown = this.findDropdown();
        return dropdown && dropdown.find('.awsui-dropdown-status');
    };
    AutosuggestWrapper.prototype.findErrorRecoveryButton = function () {
        var statusIndicator = this.findStatusIndicator();
        return statusIndicator && statusIndicator.find('.awsui-dropdown-recovery-button');
    };
    /**
     * Selects a suggestion from the dropdown by simulating mouse events.
     *
     * @param index 1-based index of the suggestion to select.
     */
    AutosuggestWrapper.prototype.selectSuggestion = function (index) {
        // Call `findOption` repeatedly to react to changes of the DOM during the event chain
        this.findDropdown()
            .findOption(index)
            .fireEvent(new dom_1.MouseEvent('mousedown'));
        this.findNativeInput().blur();
        this.findDropdown()
            .findOption(index)
            .fireEvent(new dom_1.MouseEvent('mouseup'));
    };
    /**
     * Selects a suggestion from the dropdown by simulating mouse events.
     *
     * @param value value of suggestion to select
     */
    AutosuggestWrapper.prototype.selectSuggestionByValue = function (value) {
        // Call `findOption` repeatedly to react to changes of the DOM during the event chain
        this.findDropdown()
            .findOptionByValue(value)
            .fireEvent(new dom_1.MouseEvent('mousedown'));
        this.findNativeInput().blur();
        this.findDropdown()
            .findOptionByValue(value)
            .fireEvent(new dom_1.MouseEvent('mouseup'));
    };
    __decorate([
        dom_1.usesDom
    ], AutosuggestWrapper.prototype, "selectSuggestion", null);
    __decorate([
        dom_1.usesDom
    ], AutosuggestWrapper.prototype, "selectSuggestionByValue", null);
    return AutosuggestWrapper;
}(awsui_input_1.default));
exports.default = AutosuggestWrapper;
//# sourceMappingURL=awsui-autosuggest.js.map